import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const editComment = (context: CommentContext, commentId: number, comment: string) =>
  createGenericDispatcher({
    name: 'EDIT_COMMENT',
    loadFunction: () =>
      Api.post(`/comment/${commentId}?context=${JSON.stringify(context)}`, {
        body: JSON.stringify({ comment }),
      }),
    args: { commentId, context },
  });
